import React from "react";
import "./TermsOfUse.css";

const TermsOfUse = () => {
  return (
    <div className="terms-container">
      <h1>Terms of Use</h1>
      <p>
        Welcome to Sundori. By accessing or using our app, you agree to comply
        with and be bound by the following terms and conditions:
      </p>

      <h2>1. Acceptance of Terms</h2>
      <p>
        By using Sundori, you agree to be legally bound by these terms, which
        shall take effect immediately on your first use of the app. If you do
        not agree to be legally bound by all the following terms, please do not
        access and/or use Sundori.
      </p>

      <h2>2. Use of the App</h2>
      <p>
        You agree to use Sundori only for lawful purposes. You must not use our
        app in any way that breaches any applicable local, national, or
        international law or regulation.
      </p>

      <h2>3. User Accounts</h2>
      <p>
        When creating an account, you must provide accurate and complete
        information. You are responsible for safeguarding the password that you
        use to access Sundori and for any activities or actions under your
        password.
      </p>

      <h2>4. Contributions and Identifications</h2>
      <p>
        By submitting images or other content to Sundori, you grant us a
        non-exclusive, royalty-free, perpetual, and worldwide license to use,
        store, and display the content. You are responsible for the content you
        contribute.
      </p>

      <h2>5. Intellectual Property</h2>
      <p>
        All content and materials available on Sundori, including but not
        limited to text, graphics, website name, code, images, and logos are the
        intellectual property of Sundori and are protected by applicable
        copyright and trademark law. Any inappropriate use, including but not
        limited to the reproduction, distribution, display, or transmission of
        any content on this site is strictly prohibited, unless specifically
        authorized by Sundori.
      </p>

      <h2>6. Limitation of Liability</h2>
      <p>
        In no event shall Sundori, nor its directors, employees, partners,
        agents, suppliers, or affiliates, be liable for any indirect,
        incidental, special, consequential, or punitive damages, including
        without limitation, loss of profits, data, use, goodwill, or other
        intangible losses, resulting from (i) your use or inability to use the
        app; (ii) any unauthorized access to or use of our servers and/or any
        personal information stored therein; (iii) any interruption or cessation
        of transmission to or from the app.
      </p>

      <h2>7. Privacy Policy</h2>
      <p>
        We value your privacy and are committed to protecting your personal
        information. Our Privacy Policy, which outlines how we collect, use, and
        safeguard your data, is incorporated into these Terms of Use. By using
        Sundori, you agree to the terms of our Privacy Policy.
      </p>

      <h2>8. Termination</h2>
      <p>
        We may terminate or suspend your access to Sundori immediately, without
        prior notice or liability, for any reason, including without limitation
        if you breach the terms. Upon termination, your right to use the app
        will immediately cease.
      </p>

      <h2>9. Governing Law</h2>
      <p>
        These terms shall be governed and construed in accordance with the laws
        of [Your Country/State], without regard to its conflict of law
        provisions.
      </p>

      <h2>10. Changes to the Terms</h2>
      <p>
        We may revise these terms at any time by updating this page. You are
        advised to check this page regularly to ensure you are aware of any
        changes. Your continued use of Sundori after changes are posted
        constitutes your acceptance of the amended terms.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have any questions about these Terms of Use, please contact us at
        contact@latechnologies.net.
      </p>
    </div>
  );
};

export default TermsOfUse;
